// extracted by mini-css-extract-plugin
export default {"textarea":"Textarea_textarea__oWwm1","outlined":"Textarea_outlined__XZ0p3","default":"Textarea_default__C6ohL"};